import React from 'react'
import DollarSmile from '../../img/svgComponents/DollarSmile'
import LoneBandit from '../../img/svgComponents/LoneBandit'
import DollarWallet from '../../img/svgComponents/DollarWallet'
import SectionWrapper from '../Sections/SectionWrapper/SectionWrapper'
import { casinoGames } from '../Sections/CasinoGamesSection/casino-games'
import { Link } from 'react-router-dom'
import Utils from '../../core/Utils'
import Shadow from '../../img/svgComponents/Shadow'
import Favourite from '../../img/svgComponents/Favourite'
import { useTranslation } from '../../hooks/useTranslation'

const TabContentStatistics = () => {
	const topWins = casinoGames.filter((game) => game.category.includes('Top'))
	const lastWins = casinoGames.filter((game) => game.category.includes('Favorites'))
	const { getTexts } = useTranslation(true)
	return (
		<div className="tab-content-statistics">
			<div className="statistics">
				<div className="statistics-card wins">
					<div className="statistics-card-icon">
						<DollarSmile />
					</div>
					<div className="statistics-card-title">{getTexts('wins')}</div>
					<div className="statistics-card-amount">
						<span>EUR</span>
						1024.03
					</div>
				</div>
				<div className="statistics-card bets">
					<div className="statistics-card-icon bandit">
						<LoneBandit />
					</div>
					<div className="statistics-card-title">{getTexts('bets')}</div>
					<div className="statistics-card-amount">134</div>
				</div>
				<div className="statistics-card wagered">
					<div className="statistics-card-icon">
						<DollarWallet />
					</div>
					<div className="statistics-card-title">{getTexts('wagered')}</div>
					<div className="statistics-card-amount">
						<span>EUR</span>
						{254.74}
					</div>
				</div>
			</div>
			<SectionWrapper title="Top wins">
				{topWins.map((game) => (
					<div className="statistics-games">
						<div className="statistics-game-shadow">
							<Shadow />
						</div>
						<div className="statistics-game-favourite">
							<Favourite />
						</div>
						<div
							key={game.ext_id}
							className="game statistics-game"
							style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/${game.thumbnail_url}')`, width: '93px', height: '93px', borderRadius: '4px' }}
						></div>
						<div className="statistics-game-amount">
							<span>EUR</span>
							{Utils.getRandomNumber()}
						</div>
					</div>
				))}
			</SectionWrapper>
			<SectionWrapper title="Last wins">
				{lastWins.map((game) => (
					<div className="statistics-games">
						<div className="statistics-game-shadow">
							<Shadow />
						</div>
						<div className="statistics-game-favourite">
							<Favourite />
						</div>
						<div
							key={game.ext_id}
							className="game statistics-game"
							style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/${game.thumbnail_url}')`, width: '93px', height: '93px', borderRadius: '4px' }}
						></div>
						<div className="statistics-game-amount">
							<span>EUR</span>
							{Utils.getRandomNumber()}
						</div>
					</div>
				))}
			</SectionWrapper>

			<SectionWrapper title="Last played">
				{casinoGames.map((game) => (
					<div key={game.ext_id} className="game" style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/${game.thumbnail_url}')`, minHeight:'160px', minWidth:'160px' }}>
						<div className="game-overlay">
							<Link to={`/game/${game.ext_id}`}>
								<div className="btn">Play!</div>
							</Link>
						</div>
					</div>
				))}
			</SectionWrapper>
		</div>
	)
}

export default TabContentStatistics
